/**
 * Exchange Entity Definition
 */
import { ExchangeSchema, ExchangeServerSchema, TradingAssetSchema } from "../schemas/relations";
import { defineEntity } from "./core";
// Server entity (nested in exchange)
export const ExchangeServerEntityDef = defineEntity({
    name: "exchange-server",
    schema: ExchangeServerSchema,
    relations: {},
});
// Trading asset entity (nested in exchange)
export const TradingAssetEntityDef = defineEntity({
    name: "trading-asset",
    schema: TradingAssetSchema,
    relations: {},
});
export const ExchangeEntityDef = defineEntity({
    name: "exchange",
    schema: ExchangeSchema,
    relations: {
        servers: { type: "many", entity: () => ExchangeServerEntityDef },
        trading_assets: { type: "many", entity: () => TradingAssetEntityDef },
    },
});
